import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'search-box, search',
    template: `
  <div class='search-container'>
    <div class='search-box' NgForm [formGroup]='form'>
        <i class='fa fa-search'></i>
        <input type='text' formControlName='search' [placeholder]='placeholder' autocomplete="..." [autofocus]="autofocus" #search>
    </div>
    </div>
    `,
    styleUrls: ['search.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SearchBoxComponent implements OnInit, OnChanges, AfterViewInit {

  @Output() public search = new EventEmitter<{ search: string }>();
  @Input() public filter = '';
  @Input() placeholder = '';
  @Input() autofocus = false;

  @ViewChild('search', { static: true }) searchInput: ElementRef<HTMLInputElement>;

  public form: UntypedFormGroup;

  constructor(private builder: UntypedFormBuilder) {
    this.form = this.builder.group({
      search: ['', []]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.form) return;

    if (changes.filter) {

      if (changes.filter.currentValue === changes.filter.previousValue) {
        return;
      }

      const currentEmpty = changes.filter.currentValue === null || changes.filter.currentValue === '';
      const previousEmpty = changes.filter.previousValue === null || changes.filter.previousValue === '';

      if (currentEmpty && previousEmpty)
        return;

      if (this.filter === '')
        this.form.reset();
      else
        this.form.patchValue({ search: this.filter }, { onlySelf: true, emitEvent: false });
    }

  }

  ngOnInit() {

    this.form.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe(search => {
        this.search.emit(search);
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.autofocus) {
        this.searchInput.nativeElement.focus();
      }
    }, 100);
  }
}
